module.exports = "https://www.gc-qa.gnp.com.mx/8275e57c5bad98760bb7b972f247782b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/vivir-es-increible.gif
// module id = 8176
// module chunks = 0